export enum ActionAmlTimeout {
  Allow = 'ALLOW',
  Block = 'BLOCK',
}
